@import '../../../global/reset';

:host {
	display: flow-root;
}

:host(.no-bar) {
	.slides {
		&::after {
			display: none;
			visibility: hidden;
		}
	}
}

:host(.no-slide-desk) {
	.slides {
		@media only screen and (min-width: 1200px) {
			max-width: 1000px;
			margin: auto;
			gap: 2rem;
			flex-wrap: wrap;
		}
	}
}

.viewport {
	position: relative;
}

.slides {
	--gap: 1rem;
	max-inline-size: 100%;
	max-block-size: inherit;
	display: flex;
	gap: var(--gap);
	overflow: auto;
	scroll-snap-type: both mandatory;
	scroll-behavior: smooth;

	& > slot::slotted(*) {
		scroll-snap-align: center;
		max-inline-size: 100%;
		max-block-size:  100%;
	}
	&::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 10rem;
		background-color: $quarternary;
		bottom: -1rem;
		z-index: -1;
		overflow-x: hidden;
	}
	&.no-btns-arrows {
		justify-content: center;
	}
}

.arrows, .bullets, .autoplay-toggle {
	margin-block: 0.5rem;
	margin-inline: auto;
}

.arrows, .bullets {
	display: flex;
	align-items: center;
	justify-content: center;
	inline-size: fit-content;
}

.bullets {
	flex-wrap: wrap;
}

.arrows button,
.autoplay-toggle {
	display: grid;
	place-content: center;
	background-color: $light-tan;
	border: 1px solid $darker-gold;
	aspect-ratio: 1;
	inline-size: 2.75rem;
	block-size:  2.75rem;

	svg {
		inline-size: 1rem;
		block-size:  1rem;
	}

	&:not(:disabled):is(:hover, :focus-visible) {
		color: white;
		background-color: $lighter-gold;
	}

	&:disabled {
		opacity: 0.25;
	}
}

.arrows {
	gap: calc(100vw - 9.5rem);
	button {
		transform: translateY(2rem);
		&.left {
			img {
				rotate: 180deg;
			}
		}
	}
}

.bullets {
	gap: 0.75rem;
	max-width: calc(100vw - 12rem);

	button {
		aspect-ratio: 1;
		inline-size: 1rem;
		block-size:  1rem;
		border-radius: 50%;
		display: grid;
		background-color: $light-tan;
		border: 1px solid $darker-gold;
		border-radius: 0;
		transform: translateY(-0.4375rem);

		&:not(
			[aria-selected='true'],
			:hover, :focus-visible
		) {
			opacity: 0.5;
		}

		&[aria-selected='true'] {
			background-color: $darker-gold;
			transform: scale(1.5) translateY(-0.3125rem);
		}
	}
}

:host(:not(.with-scrollbar)) {
	.slides {
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}
	}
}
:host(.with-scrollbar) {
	--scrollbar-color: var(--bs-primary);
	--scrollbar-background-color: white;

	.slides {
		padding-block-end: 0.5rem;
		scrollbar-width: thin;
		scrollbar-color: var(--scrollbar-color) var(--scrollbar-background-color);

		&::-webkit-scrollbar,
		&::-webkit-scrollbar-thumb {
			border-radius: 99px;
		}

		&::-webkit-scrollbar {
			background-color: var(--scrollbar-background-color);
			block-size: 0.5rem;
		}

		&::-webkit-scrollbar-thumb {
			background-color: var(--scrollbar-color);
		}
	}
}

:host(.faded-edges) {
	--padding-inline: 4ch;
	--bg-color: white;

	.viewport {
		inline-size: calc(100% + 2 * var(--padding-inline));
		transform: translateX(calc(-1 * var(--padding-inline)));

		&::before, &::after {
			content: '';
			position: absolute;
			inset-block: 0;
			block-size: 100%;
			inline-size: var(--padding-inline);
		}

		&::before {
			z-index: 1;
			background-image: linear-gradient(to right, var(--bg-color), transparent);
			inset-inline-start: -1px;
		}

		&::after {
			background-image: linear-gradient(to left, var(--bg-color), transparent);
			inset-inline-end: -1px;
		}
	}

	.slides {
		scroll-padding-inline: var(--padding-inline);
	}

	.slides,
	.arrows,
	.bullets {
		padding-inline: var(--padding-inline);
	}
}

:host(.faded-edges.with-scrollbar) {
	.slides {
		&::-webkit-scrollbar-track {
			margin-inline: var(--padding-inline);
		}
	}
}

:host(.fixed-slide-count) {
	--count: 1;

	.slides > slot::slotted(*) {
		scroll-snap-align: start;
		flex-shrink: 0;
		inline-size: calc(
			(100% -
				(var(--count) - 1) * var(--gap)
			)
			/ var(--count)
		);
		min-inline-size: min-content;
	}
}

:host(.inverted) {
	.arrows button,
	.autoplay-toggle {
		color: white;
		background: none;

		&:not(:disabled):is(:hover, :focus-visible) {
			color: var(--bs-primary);
			background-color: white;
		}
	}

	.bullets {
		button {
			background-color: white;
		}
	}
}